export const NO_ASAP_FOR_DELIVERY_AND_PICKUP =
  'no_asap_for_delivery_and_pickup';
export const NO_SET_ADDRESS = 'no_set_address';
export const ASAP_NOT_AVAILABLE_FOR_THROTTLES =
  'asap_not_available_for_throttles';
export const ORDERING_NOT_CURRENTLY_AVAILABLE =
  'ordering_not_currently_available';
